
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import Dialog from "@/components/publicComponents/dialog";
export default {
name: "FundDetail",
components: {
Cell,
Group,
XInput,
XButton,
"my-dialog": Dialog,
},
props: ["message", "btnText"], // btnText =》 按钮文字 message暂时不用
data() {
return {
from: {
pwd: "",
},
bg: "#bebebe",
canPay: true, // 是否可以支付 true为不可支付
};
},
created() {},
mounted() {

this.$refs.pwd.focus();
},
destroyed() {},
methods: {

buy() {
this.$emit("buyPost", this.from.pwd);
this.from.pwd = "";
},
clickPwd() {
console.log("clickPwd" + this.$refs.pwd);
this.$refs.pwd.focus();
},

closePwd() {
this.from.pwd = "";
this.$emit("closePwd", "");
},

changePwd(val) {
try {
if (val.length === 6) {
this.buy();
this.canPay = false;
} else {
this.canPay = true;
}
} catch (e) {
console.log(e);
}
},
},
};



// WEBPACK FOOTER //
// ./src/components/publicComponents/pwd.vue